module.exports = __webpack_public_path__ + "img/folder-fill.4b37ccee.svg";